// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__35LrK","dark":"Button_dark__2jjK0"};